import { DomainError } from '@dma/shared';

/**
 * Raised when Hero content violates a business/SEO rule (e.g. missing
 * headline, or a headline too long for a well-formed H1/meta title).
 * Per docs/architecture/05-error-handling-strategy.md, this stays inside
 * the feature's domain layer — it is mapped to a generic AppError by the
 * Application layer before it could ever reach the UI.
 */
export class InvalidHeroContentError extends DomainError {
  constructor(reason: string) {
    super('INVALID_HERO_CONTENT', `Hero content is invalid: ${reason}`);
    this.name = 'InvalidHeroContentError';
    Object.setPrototypeOf(this, InvalidHeroContentError.prototype);
  }
}
